import { Field, Input } from "@/components/ui/Input";

export type PersonNameValue = {
  firstName: string;
  secondName: string;
  firstSurname: string;
  secondSurname: string;
};

export function emptyPersonName(): PersonNameValue {
  return { firstName: "", secondName: "", firstSurname: "", secondSurname: "" };
}

/** Western-order hint (nombres then apellidos). Never persist without confirmation. */
export function suggestPersonName(fullName: string): PersonNameValue {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return emptyPersonName();
  if (words.length === 1) {
    return { firstName: words[0]!, secondName: "", firstSurname: "", secondSurname: "" };
  }
  if (words.length === 2) {
    return { firstName: words[0]!, secondName: "", firstSurname: words[1]!, secondSurname: "" };
  }
  if (words.length === 3) {
    return {
      firstName: words[0]!,
      secondName: "",
      firstSurname: words[1]!,
      secondSurname: words[2]!,
    };
  }
  return {
    firstName: words[0]!,
    secondName: words.slice(1, -2).join(" "),
    firstSurname: words[words.length - 2]!,
    secondSurname: words[words.length - 1]!,
  };
}

export function PersonNameFields({
  value,
  onChange,
  required = true,
  hint,
}: {
  value: PersonNameValue;
  onChange: (next: PersonNameValue) => void;
  required?: boolean;
  hint?: string | null;
}) {
  function set<K extends keyof PersonNameValue>(key: K, v: string) {
    onChange({ ...value, [key]: v });
  }
  return (
    <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
      {hint ? (
        <p className="md:col-span-2 text-xs text-slate-500">
          Stored full name: <span className="font-medium text-slate-700">{hint}</span>
        </p>
      ) : null}
      <Field label="Primer nombre" required={required}>
        <Input
          value={value.firstName}
          onChange={(e) => set("firstName", e.target.value)}
          required={required}
          maxLength={80}
        />
      </Field>
      <Field label="Segundo nombre">
        <Input
          value={value.secondName}
          onChange={(e) => set("secondName", e.target.value)}
          maxLength={80}
        />
      </Field>
      <Field label="Primer apellido" required={required}>
        <Input
          value={value.firstSurname}
          onChange={(e) => set("firstSurname", e.target.value)}
          required={required}
          maxLength={80}
        />
      </Field>
      <Field label="Segundo apellido">
        <Input
          value={value.secondSurname}
          onChange={(e) => set("secondSurname", e.target.value)}
          maxLength={80}
        />
      </Field>
    </div>
  );
}
